import {registerGlobalInitFunc} from '../modules/observer.ts';
import {fomanticQuery} from '../modules/fomantic/base.ts';

function selectedValues($dropdown: ReturnType<typeof fomanticQuery>): string[] {
  const raw = $dropdown.dropdown('get values');
  if (Array.isArray(raw)) return raw.map(String).filter(Boolean);
  if (typeof raw === 'string' && raw) return raw.split(',').map((s) => s.trim()).filter(Boolean);
  return [];
}

function syncHidden(wrap: HTMLElement, values: string[]): void {
  const name = wrap.getAttribute('data-name');
  if (!name) return;
  wrap.replaceChildren();
  for (const value of values) {
    const inp = document.createElement('input');
    inp.type = 'hidden';
    inp.name = name;
    inp.value = value;
    wrap.append(inp);
  }
}

function initCreateUserMembership(root: HTMLElement): void {
  const orgEl = root.querySelector<HTMLElement>('#create-user-orgs');
  const teamEl = root.querySelector<HTMLElement>('#create-user-teams');
  const orgFields = root.querySelector<HTMLElement>('[data-name="org_ids"]');
  const teamFields = root.querySelector<HTMLElement>('[data-name="team_ids"]');
  if (!orgEl || !teamEl || !orgFields || !teamFields) return;

  const $org = fomanticQuery(orgEl);
  const $team = fomanticQuery(teamEl);
  const teamItems = [...teamEl.querySelectorAll<HTMLElement>('.menu > .item[data-value]')];

  function applyTeamFilter(): void {
    const orgs = new Set(selectedValues($org));
    const keep: string[] = [];
    for (const item of teamItems) {
      const inOrg = orgs.has(item.getAttribute('data-org') || '');
      item.classList.toggle('not-in-org', !inOrg);
      if (inOrg && item.classList.contains('active')) keep.push(item.getAttribute('data-value') || '');
    }
    teamEl.classList.toggle('disabled', orgs.size === 0);
    const kept = keep.filter(Boolean);
    if (kept.length) $team.dropdown('set exactly', kept);
    else $team.dropdown('clear');
    syncHidden(teamFields, kept);
  }

  $org.dropdown({
    fullTextSearch: true,
    forceSelection: false,
    onChange() {
      syncHidden(orgFields, selectedValues($org));
      applyTeamFilter();
    },
  });
  $team.dropdown({
    fullTextSearch: true,
    forceSelection: false,
    onChange() {
      syncHidden(teamFields, selectedValues($team));
    },
  });

  if (orgEl.getAttribute('data-empty') === 'true') {
    orgEl.classList.add('disabled');
  }

  applyTeamFilter();
  syncHidden(orgFields, selectedValues($org));
}

export function initCreateUserMembershipFeature(): void {
  registerGlobalInitFunc('initCreateUserMembership', initCreateUserMembership);
}
